export default {
  apiUrl: "https://api.freshcasting.ru/api",
};
